"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Event = void 0;
var Event;
(function (Event) {
    Event["LocalSettingUpdated"] = "LOCAL_SETTING_UPDATED";
    Event["RemoteSettingUpdated"] = "REMOTE_SETTING_UPDATED";
})(Event || (exports.Event = Event = {}));
